import {debugLog} from "../Utils/LogUtils";
import {useEffect} from "react";
import moment from "moment/moment";

export default function useSetCLBBasedOnBirthdate(state) {
    //When the beneficiary birthdate is set, we can set the Canada Learning Bond as long as the bene was born after 2004
    /*
    useEffect(() => {
        if (!state.beneficiary.birthdate) { return; }

        state.setApplication({
            ...state.application,
            grantCanadaLearningBond: (moment(state.beneficiary.birthdate).year() >= 2004)
        });
        debugLog("useSetCLBBasedOnBirthdate");
    }, [state.beneficiary.birthdate]);

     */

    //TODO: This whole file can probably be removed
}